import { render, staticRenderFns } from "./FilmDescription.vue?vue&type=template&id=9d9afe5a&scoped=true&"
import script from "./FilmDescription.vue?vue&type=script&lang=ts&"
export * from "./FilmDescription.vue?vue&type=script&lang=ts&"
import style0 from "./FilmDescription.vue?vue&type=style&index=0&id=9d9afe5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9afe5a",
  null
  
)

export default component.exports